import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { Person } from 'talent_matching/types';
import Questions from './questions';

type Props = {
  candidate: Person | null;
};

const ApplicationTabPanel = ({ candidate }: Props) => {
  return (
    <Stack spacing={2}>
      <Questions
        questions={candidate?.applicationQuestions}
        type="application_questions"
      />
      <Questions
        questions={candidate?.agencyQuestions}
        type="agency_questions"
      />
      <Questions
        questions={candidate?.referralDetails}
        type="referral_details"
      />
    </Stack>
  );
};

export default ApplicationTabPanel;
